import { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'

// The login's small menu (click your name at the foot of the sidebar). On document.body: the sidebar clips what leaves it.
export default function UserMenu({ children, style, compact }) {
  const [at, setAt] = useState(null)
  const btn = useRef(null)
  useEffect(() => {
    if (!at) return
    const k = e => { if (e.key === 'Escape') { e.stopPropagation(); setAt(null); btn.current && btn.current.focus() } }
    window.addEventListener('keydown', k, true)
    return () => window.removeEventListener('keydown', k, true)
  }, [at])
  const toggle = () => {
    if (at) { setAt(null); return }
    const r = btn.current.getBoundingClientRect()
    setAt({ left: Math.max(8, r.left), bottom: window.innerHeight - r.top + 8 })
  }
  const go = name => { setAt(null); window.dispatchEvent(new CustomEvent(name)) }
  return (
    <>
      <button ref={btn} type="button" className={'hc-user-btn' + (compact ? ' compact' : '')} aria-haspopup="menu" aria-expanded={!!at} aria-label="Your menu" title="Your menu" onClick={toggle} style={style}>{children}</button>
      {at && createPortal(
        <div className="hc-user-scrim" onClick={() => setAt(null)}>
          <div className="hc-user-menu" role="menu" aria-label="Your menu" style={at} onClick={e => e.stopPropagation()}>
            <button type="button" role="menuitem" autoFocus onClick={() => go('hc-tour-start')}>Restart tutorial</button>
            <button type="button" role="menuitem" onClick={() => go('hc-checklist-open')}>Getting started</button>
          </div>
        </div>, document.body)}
    </>
  )
}
